/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import IconEmpty from '@assets/icons/empty.svg?react';
import {
 Box,
 debounce,
 FormControl,
 IconButton,
 InputAdornment,
 InputLabel,
 MenuItem,
 Popover,
 Select,
 TextField,
 useTheme,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { MutableRefObject, SetStateAction, useCallback, useMemo } from 'react';
import { Controller } from 'react-hook-form';

import SelectApi from '../SelectApi';
import { CustomGridApi } from '../XTable/types';
import useFilterMenu from './useFilterMenu';

const FilterMenu = ({
 filterMenuState,
 setOpen,
 apiRef,
}: {
 filterMenuState: {
  anchorElement: HTMLDivElement | HTMLButtonElement | null;
  colName: string;
 } | null;
 setOpen: SetStateAction<any>;
 apiRef: MutableRefObject<CustomGridApi>;
}) => {
 const th = useTheme();
 const {
  currentFilter,
  handleChange,
  handleDelete,
  currentType,
  currentStructure,
  control,
  formState,
  anchorElement,
  translation,
  getValues,
  colName,
 } = useFilterMenu({ filterMenuState, apiRef, setOpen });

 // Debounce the handleChange function
 const debouncedChange = useCallback(
  debounce((name, value) => {
   handleChange(name, value);
  }, 1000), // Adjust delay as needed
  [handleChange],
 );

 console.log(currentStructure);

 const returnEl = useMemo(() => {
  let returnObj = null;

  switch (currentType) {
   case 'model':
    returnObj = (
     <SelectApi
      name={colName}
      url={currentStructure.ForeignKeyUrl}
      filter={currentStructure.ForeignKeyDefaultFilter}
      label={translation}
      isEditable
      operator="contains"
      control={control}
      setValue={handleChange}
      multiple
     />
    );
    break;
   case 'array':
    returnObj = (
     <SelectApi
      name={colName}
      url={currentStructure.ForeignKeyUrl}
      filter={currentStructure.ForeignKeyDefaultFilter}
      label={translation}
      isEditable
      operator="contains"
      control={control}
      setValue={handleChange}
      multiple
     />
    );
    break;
   case 'datetime':
    returnObj = (
     <Box sx={{ display: 'flex', gap: 1 }}>
      <Box sx={{ flex: 1 }}>
       <Controller
        name="DateFrom"
        control={control}
        render={({ field }) => (
         <DateTimePicker
          views={['year', 'month', 'day', 'hours', 'minutes']}
          {...field}
          slotProps={{
           field: {
            clearable: true,
            onClear: () => handleChange('DateFrom', ''),
           },
          }}
          sx={{
           backgroundColor: 'white',
           width: '100%',
          }}
          value={field.value ? dayjs(field?.value) : null}
          onChange={(value) => {
           handleChange('DateFrom', value);
          }}
          label={`${translation} nuo`}
         />
        )}
       />
      </Box>
      <Box sx={{ flex: 1 }}>
       <Controller
        name="DateTo"
        control={control}
        render={({ field }) => (
         <DateTimePicker
          views={['year', 'month', 'day', 'hours', 'minutes']}
          {...field}
          slotProps={{
           field: {
            clearable: true,
            onClear: () => handleChange('DateTo', ''),
           },
          }}
          sx={{
           backgroundColor: 'white',
           width: '100%',
          }}
          value={field.value ? dayjs(field?.value) : null}
          onChange={(value) => {
           handleChange('DateTo', value);
          }}
          label={`${translation} iki`}
         />
        )}
       />
      </Box>
     </Box>
    );
    break;
   case 'enum':
    returnObj = (
     <FormControl key={currentStructure.Name} sx={{ width: '100%' }}>
      <InputLabel htmlFor={currentStructure.Name}>{translation}</InputLabel>
      <Controller
       name={colName}
       control={control}
       render={({ field }) => (
        <Select
         {...field}
         id={currentStructure.Name}
         renderValue={(selected) =>
          currentStructure.EnumValues[selected] || 'Select an option'
         }
         onChange={(e: any, value: any) => {
          handleChange(currentStructure.Name, e.target.value || '');
         }}
         value={typeof field.value !== 'undefined' ? field.value : ''}
         label={translation}
         sx={{
          backgroundColor: 'white',
         }}
         endAdornment={
          field.value && (
           <InputAdornment
            sx={{ position: 'absolute', right: 32 }}
            position="end"
           >
            <IconButton
             onClick={() => {
              handleChange(currentStructure.Name, '');
             }}
            >
             <IconClose style={{ width: 14, height: 14 }} />
            </IconButton>
           </InputAdornment>
          )
         }
        >
         {Object.entries(currentStructure.EnumValues).map(([value, label]) => (
          <MenuItem key={value} value={value}>
           {label}
          </MenuItem>
         ))}
        </Select>
       )}
      />
     </FormControl>
    );
    break;
   default:
    returnObj = (
     <Controller
      name={colName}
      control={control}
      //  defaultValue=""
      render={({ field }) => (
       <TextField
        {...field}
        value={field.value || ''}
        onChange={(e) => {
         const value = e.target.value || '';
         console.log('onChange', currentStructure.Name, value);
         field.onChange(value); // update RHF state immediately
         debouncedChange(currentStructure.Name, value); // debounce side effect
        }}
        label={currentStructure.Translation}
        variant="filled"
        error={!!formState?.errors?.[currentStructure.Name]}
        fullWidth
       />
      )}
     />
    );
    break;
  }
  return returnObj;
 }, [currentFilter]);
 return (
  anchorElement && (
   <Popover
    id="limit-modal"
    open={!!anchorElement}
    anchorEl={anchorElement}
    onClose={() => setOpen(false)}
    anchorOrigin={{
     vertical: 'bottom',
     horizontal: 'left',
    }}
   >
    <Box
     // component="form"
     // noValidate
     sx={{
      borderRadius: '4px',
      border: `1px solid ${th.palette.kemek.lightestGray}`,
      backgroundColor: th.palette.kemek.lightBlue,
      p: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
     }}
    >
     {returnEl ? (
      <Box
       sx={{
        width: '100%',
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
       }}
      >
       <Box sx={{ flex: 1, minWidth: 150 }}>{returnEl}</Box>

       <IconButton onClick={handleDelete}>
        <IconEmpty style={{ width: 18, height: 18 }} />
       </IconButton>
      </Box>
     ) : null}
    </Box>
   </Popover>
  )
 );
};

export default FilterMenu;
